import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { apiClient } from "../../utils/api";

interface GoogleSignupData {
  code: string;
  redirect_url: string;
  code_verifier: string;
  nonce: string;
  private_agreement: boolean;
  service_agreeement: boolean;
  marketing_agreement: boolean;
}

interface UseGoogleSignupReturn {
  isLoading: boolean;
  error: string;
  signupWithGoogle: (data: GoogleSignupData) => Promise<void>;
  clearError: () => void;
}

const useGoogleSignup = (): UseGoogleSignupReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  
  const signIn = useAuthStore((state) => state.signIn);

  const signupWithGoogle = async (data: GoogleSignupData) => {
    setIsLoading(true);
    setError("");

    try {
      const response = await apiClient.post("/api/v1/auth/google_signup_20250916", {
        code: data.code,
        redirect_url: data.redirect_url,
        code_verifier: data.code_verifier,
        nonce: data.nonce,
        private_agreement: data.private_agreement,
        service_agreeement: data.service_agreeement,
        marketing_agreement: data.marketing_agreement,
      });

      const result = response.data;

      if (!result.status) {
        throw new Error(result.error || "구글 회원가입에 실패했습니다.");
      }

      // 회원가입 성공 - 토큰 저장 및 대시보드로 이동
      signIn(
        {
          accessToken: result.access_token,
          refreshToken: result.refresh_token,
        },
        result.data
      );
      
      navigate("/");
    } catch (err: any) {
      console.error("구글 회원가입 오류:", err);
      setError(err.message || "구글 회원가입 중 오류가 발생했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  const clearError = () => {
    setError("");
  };

  return {
    isLoading,
    error,
    signupWithGoogle,
    clearError,
  };
};

export default useGoogleSignup;
